export default __webpack_public_path__ + "static/media/2143.7a28493d.png";